import { useQuery } from '@tanstack/react-query';
import { getDataRoomEntitlement } from '../api/data-room.api';
import { dataRoomKeys } from './data-room.keys';

/**
 * The backend's entitlement decision for one startup's data room - the single
 * source for whether the launch affordance renders at all.
 *
 * Disabled until a startup id is known, so no request fires for a persona that
 * has no data room to be entitled to (individuals, investors, partners, super
 * admins).
 *
 * @param startupId - the acting startup entity, or `null` when there isn't one
 */
export function useDataRoomEntitlement(startupId: string | null) {
  return useQuery({
    queryKey: dataRoomKeys.entitlement(startupId ?? ''),
    queryFn: () => getDataRoomEntitlement(startupId as string),
    enabled: Boolean(startupId),
  });
}
